import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild, ViewChildren, QueryList, Renderer2, ChangeDetectorRef, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FloorMapComponent } from '../floor-map/floor-map.component';
import { FloorService } from '../../../core/services/floor.service';
import { FormsModule } from '@angular/forms';
import _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationService } from '../../../core/services/organization.service';
import { DataService, BleWifiQueryRequest } from '../../../core/services/data.service';
import { CameraService } from '../../../core/services/camera.service';
import { catchError, forkJoin, map, Observable, of, switchMap, Subscription } from 'rxjs';
import { DetailsModalComponent } from '../organization/details-modal/details-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { SessionOptionsService } from '../../../core/services/session-option.service';
import { UserSearchUiComponent } from '../user-search-ui/user-search-ui.component';
import { MultipleMessageComponent } from '../organization/multiple-message/multiple-message.component';
import * as Cesium from 'cesium';
import { PluginContextService } from '../../../core/services/plugin-context.service';
import { CoreService } from '../../../core/services/core.service';
import { CreateUpdateDialogComponent } from '../create-update-dialog/create-update-dialog.component';
import { DeviceService } from '../../../core/services/device.service';
import moment from 'moment';
import { ThreeIntegrationService } from '../../../core/services/three-js-building.service';
import { ResponseModalComponent } from '../response-modal/response-modal.component';
import { BlenderFloorViewerComponent } from '../blender-floor-viewer/blender-floor-viewer.component';
import { DataContextService } from '../../../core/services/data-context.service';
import { GlobeService } from '../../../core/services/globe.service';
import { WindowService } from '../../../core/services/window.service';
import { WifiDevicesComponent } from '../wifi-devices/wifi-devices.component';
import { BleWifiDevicesComponent } from '../ble-wifi-devices/ble-wifi-devices.component';
import { OrganizationUtilService } from '../../../core/services/organization-util.service';
import { GlbFloorViewComponent } from '../glb-floor-view/glb-floor-view.component';
import { UserClusterListUiComponent } from '../user-cluster-list-ui/user-cluster-list-ui.component';
interface User {
  name: string;
  src: string;
  visible: boolean;
  status: string;
  userId?: string;
  deviceId?: string;
}

interface Perimeter {
  getName(): string;
  getNumberOfUnknownUsers(): number;
  getNumberOfSafeUsers(): number;
  getNumberOfUnSafeUsers(): number;
  // ...other methods as needed
}
@Component({
  selector: 'app-floor-visualizer',
  standalone: true,
  imports: [CommonModule, FormsModule, FloorMapComponent, BlenderFloorViewerComponent, GlbFloorViewComponent, WifiDevicesComponent, BleWifiDevicesComponent],
  templateUrl: './floor-visualizer.component.html',
  styleUrl: './floor-visualizer.component.css',
})
export class FloorVisualizerComponent implements OnDestroy {

  @ViewChild('noUsersModal') noUsersModal!: TemplateRef<any>;
  @ViewChild(FloorMapComponent) floorMapComponent?: FloorMapComponent;
  @ViewChildren(BlenderFloorViewerComponent) blenderViewers!: QueryList<BlenderFloorViewerComponent>;
  @ViewChild('glbFloorView') glbFloorView?: GlbFloorViewComponent;
  isFullScreenBlender = false;

  showGlobeClick = false;
  @Input() floorMapEntity: any = {};
  @Input() liveData: any
  private _liveUserData: any = null;
  private lastFloorUserDevicesRawWasEmpty = false;

  @Input() set liveUserData(value: any) {
    this._liveUserData = value;
    // Don't override blenderLiveUserData with empty data (no records and no roomStatusByRoomId)
    const isEmpty = value && (
      (!value.records || value.records.length === 0) &&
      (!value.roomStatusByRoomId || Object.keys(value.roomStatusByRoomId).length === 0)
    );
    const shouldUse = value && !isEmpty && !this.blenderLiveUserData && !this.lastFloorUserDevicesRawWasEmpty;
    if (shouldUse) {
      this.blenderLiveUserData = value;
      this.cdr.detectChanges();
    }
  }
  get liveUserData(): any {
    return this._liveUserData;
  }
  @Input() assetResolutionKey: string | null = null;
  @Input() alertRecords: any[] = [];
  blenderViewEnabled = false;
  blenderViewLoading = false;
  blenderLiveUserData: any = null;
  showCameraLayer = false;
  showAccessControlLayer = false;
  showRaspberryPiLayer = false;
  showBeaconLayer = false;
  numberOfCameras = 0;
  numberOfAccessControls = 0;
  numberOfRaspberryPis = 0;
  numberOfBeacons = 0;
  raspberryPiDevices: any[] = [];
  raspberryPiTotal: number = 0;
  raspberryPiPage: number = 1;
  raspberryPiLimit: number = 50;
  raspberryPiTotalPages: number = 1;
  raspberryPiResponse: any = null;
  raspberryPiLoading: boolean = false;
  raspberryPiSearchQuery: string = '';
  selectedPlatformFilter: string = 'ALL';
  selectedTransportFilter: string = 'ALL';
  selectedTimeRange: string = '5min';
  raspberryPiBleCount: number = 0;
  raspberryPiWifiCount: number = 0;
  raspberryPiTotalCount: number = 0;
  selectedDevice: any = null;
  bleWifiDevicesFromTab: any[] = [];
  numberOfDevicesWithCoords: number = 0;
  private transportCountSubs: Subscription[] = [];
  leafletFloorHeight = '400px';
  expandLeaflet = false;
  tabHeight = '300px';
  data = {
    totalCount: 0,
    dangerCount: 0,
    safeCount: 0,
    unknownCount: 0,
    suspectCount: 0,
    totalUserCount: 0,
    page: 1,
    lastPage: 1,
    limit: 30,
    threshold: 250,
    gridSize: 10,
    userList1: [] as User[],
    userList2: [] as User[],
    userList3: [] as User[],
    allUsers: [] as User[],
    dangerChecked: true,
    safeChecked: true,
    unknownChecked: true,
    suspectChecked: true,
    show3DUserClusters: true,
  };

  // Store original counts to preserve them when filtering
  private originalDangerCount: number = 0;
  private originalSafeCount: number = 0;
  private originalUnknownCount: number = 0;
  private originalSuspectCount: number = 0;
  sidebarLeafletView: { lat: number; lng: number; zoom: number } | null = null;
  fullUsers: User[] = [];
  allUsers: any;
  updates: any[] = [];
  scrollHeight = '200px';
  sopInfo = {
    sopTask: { label: '', type: '', stepsCompleted: 0, totalNumberOfSteps: 0 },
    sopTaskStep: [],
  };
  cameraListForFloor: any[] = [];
  accessControlListForFloor: any[] = [];
  raspberryPiListForFloor: any[] = [];
  perimeters: any[] = [];
  beaconsVisible: boolean = false;
  activeTab: string = 'user';
  cameraVisible: boolean = true;
  showTabs = true;
  commands: any[] = [];
  enablePlayback: boolean | undefined;
  enableMonitor: boolean | undefined;
  enableInteraction: boolean | undefined;
  longitude: any;
  latitude: any;
  @Input() tempLat: number = 0.0;
  @Input() tempLong: number = 0.0;
  icon: string = 'assets/img/default_entity.png';
  searchVisible: boolean = false;
  searchQuery: string = '';
  filteredUsers: User[] = [];

  // Running time - updated continuously via interval
  currentRunningTime: Date = new Date();
  private timeInterval: any;

  // Keep original lists so we can restore them after clearing search
  private origUserList1: User[] = [];
  private origUserList2: User[] = [];
  private origUserList3: User[] = [];

  // Track if status filter is active to prevent userOnFloorsChange from overwriting
  private isStatusFilterActive: boolean = false;



  // Track user visibility state to preserve across data refreshes
  private userVisibilityMap: Map<string, boolean> = new Map();
  constructor(
    private floorService: FloorService,
    private modalService: NgbModal,
    private organizationService: OrganizationService,
    private deviceService: DeviceService,
    private spinnerService: NgxSpinnerService,
    private sessionOptionService: SessionOptionsService,
    private pluginContext: PluginContextService,
    private core: CoreService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private threeJsBuildingIntegration: ThreeIntegrationService,
    private windowService: WindowService,
    private globeService: GlobeService,
    private dataContext: DataContextService,
    private dataService: DataService,
    private organizationUtilService: OrganizationUtilService
  ) { }

  private openModalA11y(content: any, options?: any): any {
    const modalRef = this.modalService.open(content, options);
    modalRef.shown.subscribe(() => {
      document.querySelectorAll('ngb-modal-window[aria-hidden="true"]').forEach((el) => {
        this.renderer.removeAttribute(el, 'aria-hidden');
      });
    });
    return modalRef;
  }

  ngOnInit() {
    this.enableInteraction = this.sessionOptionService.isLiveMode();
    this.enableMonitor = this.sessionOptionService.isMonitorMode();
    this.enablePlayback = this.sessionOptionService.isPlaybackMode();

    // Start the running time interval
    this.startTimeInterval();

    if (this.floorMapEntity && typeof this.floorMapEntity.iconUrl === 'string') {
      this.icon = this.floorMapEntity.iconUrl;
    } else if (this.floorMapEntity && (this.floorMapEntity as any).icon) {
      this.icon = (this.floorMapEntity as any).icon;
    }
    const arcLiveEntity = this.floorMapEntity;
    const allCommands = typeof arcLiveEntity.getCommands === 'function'
      ? arcLiveEntity.getCommands()
      : Array.isArray(arcLiveEntity.commands) ? arcLiveEntity.commands : [];

    const mode = this.sessionOptionService.getMode();
    for (const command of allCommands) {
      if (command.shouldShow ? command.shouldShow(mode) : true) {
        this.commands.push(command);
        if (typeof command.init === 'function') {
          command.init(arcLiveEntity);
        }
      }
    }
  }
  onCommandClick(index: number, mapEntity: any) {
    this.commands[index].execute(mapEntity);
  }
  getCurrentIncident(): any {
    const parentBuilding = this.floorMapEntity;
    if (
      parentBuilding &&
      Array.isArray(parentBuilding?.incidents) && parentBuilding?.incidents?.length > 0
    ) {
      const incident = parentBuilding.incidents[0];

      return incident;
    }

    return parentBuilding?.incidents?.[0] ?? parentBuilding?.building?.incidents[0];
  }
  isEmpty(value: any): boolean {
    return value === '' || value === null || value === undefined;
  }
  round(value: any): number | string {
    if (value === undefined || value === null || isNaN(value)) return '';
    return Math.round(parseFloat(value) * 1000000) / 1000000;
  }
  showTemporalCoordinates(): boolean {
    return this.floorMapEntity?.type === 'UnitMapEntity';
  }
  getCurrentIncidentTime(): string {
    const incident = this.getCurrentIncident();
    if (!incident || !incident.timestamp) {
      return '0:00:00';
    }
    const currentTimestamp = this.core.getCurrentTimestamp?.();
    let startTime: number;
    let endTime: number;
    if (incident.timestamp instanceof Date) {
      startTime = incident.timestamp.getTime();
    } else {
      startTime = Number(incident.timestamp);
    }
    if (currentTimestamp instanceof Date) {
      endTime = currentTimestamp.getTime() - 1000;
    } else if (typeof currentTimestamp === 'number') {
      endTime = currentTimestamp - 1000;
    } else {
      endTime = Date.now() - 1000;
    }
    const elapsedTime = this.getElapsedTime(startTime, endTime);
    return elapsedTime.startsWith('-') ? '0:00:00' : elapsedTime;
  }
  private getElapsedTime(dateStart: number, dateCurrent: number): string {
    if (typeof dateStart !== 'number' || typeof dateCurrent !== 'number') {
      return '0:00:00';
    }
    const duration = moment.duration(dateCurrent - dateStart);
    return (
      Math.floor(duration.asHours()) +
      moment.utc(duration.asMilliseconds()).format(':mm:ss')
    );
  }
  showStaticCoordinates(): boolean {
    const incident = this.getCurrentIncident();
    this.latitude =
      incident?.latitude !== undefined
        ? incident.latitude
        : (incident?.centerLatitude !== undefined
          ? incident.centerLatitude
          : incident?.centerpoint?.latitude);
    this.longitude =
      incident?.longitude !== undefined
        ? incident.longitude
        : (incident?.centerLongitude !== undefined
          ? incident.centerLongitude
          : incident?.centerpoint?.longitude);
    return !!(this.latitude && this.longitude);
  }
  formatDate(value: any): string {
    return value ? moment(value).format('MMMM Do YYYY, h:mm:ss a') : '';
  }

  // Check if incident is in running stage (has timestamp but no end time)
  isIncidentRunning(): boolean {
    const incident = this.getCurrentIncident();
    if (!incident) {
      // No incident, check if we're in live/interaction mode
      return this.enableInteraction === true;
    }
    // If incident has timestamp, consider it running
    return !this.isEmpty(incident?.timestamp);
  }

  // Start interval to update running time
  private startTimeInterval(): void {
    this.timeInterval = setInterval(() => {
      this.currentRunningTime = new Date();
      this.cdr.detectChanges();
    }, 1000);
  }

  private raspberryPiPollTimer: any = null;
  currentRaspberryPiSensorUuids: string[] = [];
  private sensorCountSubs: Subscription[] = [];
  raspberryPiSensorCounts: { [key: string]: number } = {};

  // Stop the interval and polling when component is destroyed
  ngOnDestroy(): void {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    }
    this.stopRaspberryPiPolling();
    this.transportCountSubs.forEach(s => s.unsubscribe());
    this.transportCountSubs = [];
    this.sensorCountSubs.forEach(s => s.unsubscribe());
    this.sensorCountSubs = [];
  }

  getNow(): Date {
    return new Date();
  }
  showHideCameraLayer() {
    /* ... */
  }
  showHideAccessControlLayer() {
    /* ... */
  }
  showHideRaspberryPiLayer() {
    if (this.showRaspberryPiLayer) {
      this.fetchRaspberryPiDevices();
    } else if (this.activeTab !== 'raspberry-pi') {
      this.stopRaspberryPiPolling();
    }
  }

  selectTab(tabName: string) {
    this.activeTab = tabName;
    if (tabName === 'raspberry-pi') {
      this.fetchRaspberryPiDevices();
    } else if (!this.showRaspberryPiLayer) {
      this.stopRaspberryPiPolling();
    }
    this.cdr.detectChanges();
  }

  getAllBuildingPerimeterIds(): (string | number)[] {
    const ids = new Set<string | number>();
    const addId = (id: any) => {
      if (id !== null && id !== undefined && id !== '') {
        const str = String(id).trim();
        if (str !== '' && str !== 'null' && str !== 'undefined') {
          const num = Number(str);
          ids.add(!isNaN(num) && String(num) === str ? num : id);
        }
      }
    };

    const building = this.floorMapEntity?.building ?? (typeof this.floorMapEntity?.getParentBuilding === 'function' ? this.floorMapEntity.getParentBuilding() : null);

    let buildingPerimeterId: any = null;
    if (building) {
      if (building.perimeterId) {
        buildingPerimeterId = building.perimeterId;
        addId(building.perimeterId);
      }
      if (building.id) addId(building.id);
      if (building.buildingid) addId(building.buildingid);
      if (building.relationid) addId(building.relationid);

      if (Array.isArray(building.areaIds)) {
        building.areaIds.forEach((id: any) => addId(id));
      }

      const floors = typeof building.getFloorPerimeters === 'function'
        ? building.getFloorPerimeters()
        : (building.floorPerimeters || building.floors || []);

      if (Array.isArray(floors)) {
        floors.forEach((floor: any) => {
          if (floor?.perimeterId) addId(floor.perimeterId);
          if (floor?.id) addId(floor.id);
          if (floor?.arcAngelId) addId(floor.arcAngelId);

          const roomPerims = typeof floor?.getPerimeters === 'function'
            ? Object.values(floor.getPerimeters() || {})
            : Object.values(floor?.perimeters || {});

          roomPerims.forEach((p: any) => {
            if (p?.perimeterId) addId(p.perimeterId);
            if (p?.arcAngelId) addId(p.arcAngelId);
            if (p?.id) addId(p.id);
          });
        });
      }
    }

    // Floor map entity itself
    if (this.floorMapEntity) {
      if (this.floorMapEntity.perimeterId) addId(this.floorMapEntity.perimeterId);
      if (this.floorMapEntity.id) addId(this.floorMapEntity.id);
      if (this.floorMapEntity.arcAngelId) addId(this.floorMapEntity.arcAngelId);

      const floorRooms = typeof this.floorMapEntity.getPerimeters === 'function'
        ? Object.values(this.floorMapEntity.getPerimeters() || {})
        : (Array.isArray(this.floorMapEntity.perimeters)
            ? this.floorMapEntity.perimeters
            : Object.values(this.floorMapEntity.perimeters || {}));

      floorRooms.forEach((p: any) => {
        if (p?.perimeterId) addId(p.perimeterId);
        if (p?.arcAngelId) addId(p.arcAngelId);
        if (p?.id) addId(p.id);
      });
    }

    // Also from this.perimeters
    if (Array.isArray(this.perimeters)) {
      this.perimeters.forEach((p: any) => {
        if (p?.perimeterId) addId(p.perimeterId);
        if (p?.arcAngelId) addId(p.arcAngelId);
        if (p?.id) addId(p.id);
      });
    }

    // Cross reference with OrganizationUtilService.data.myPerimeters
    const myPerimeters = this.organizationUtilService?.data?.myPerimeters;
    if (myPerimeters) {
      const currentFloorId = this.floorMapEntity?.perimeterId || this.floorMapEntity?.arcAngelId || this.floorMapEntity?.id;
      if (!buildingPerimeterId && currentFloorId && myPerimeters[currentFloorId]?.ancestors) {
        const floorPerim = myPerimeters[currentFloorId];
        buildingPerimeterId = floorPerim.ancestors.find((ancId: any) => {
          const anc = myPerimeters[ancId];
          return anc && (anc.perimeterType === 'BUILDING' || anc.type === 'BUILDING');
        });
        if (buildingPerimeterId) {
          addId(buildingPerimeterId);
        }
      }

      if (buildingPerimeterId) {
        const bIdStr = String(buildingPerimeterId);
        Object.keys(myPerimeters).forEach((perimId) => {
          const p = myPerimeters[perimId];
          if (p) {
            const hasBuildingAncestor = p.ancestors && p.ancestors.some((a: any) => String(a) === bIdStr);
            if (hasBuildingAncestor || String(perimId) === bIdStr) {
              addId(perimId);
            }
          }
        });
      }
    }

    return Array.from(ids);
  }

  getBuildingIncidentId(): string | number | null {
    const incident = this.getCurrentIncident();
    if (incident) {
      const id = incident.eventId ?? incident.id ?? incident.incidentId ?? incident.incident_id;
      if (id !== undefined && id !== null && id !== '') {
        return id;
      }
    }
    const bldgIncidents = this.floorMapEntity?.building?.incidents;
    if (Array.isArray(bldgIncidents) && bldgIncidents.length > 0) {
      const inc = bldgIncidents[0];
      const id = inc.eventId ?? inc.id ?? inc.incidentId ?? inc.incident_id;
      if (id !== undefined && id !== null && id !== '') {
        return id;
      }
    }
    const entityIncidents = this.floorMapEntity?.incidents;
    if (Array.isArray(entityIncidents) && entityIncidents.length > 0) {
      const inc = entityIncidents[0];
      const id = inc.eventId ?? inc.id ?? inc.incidentId ?? inc.incident_id;
      if (id !== undefined && id !== null && id !== '') {
        return id;
      }
    }
    const liveIncident = this.liveData?.eventId ?? this.liveData?.incidentId ?? this.liveData?.id;
    if (liveIncident !== undefined && liveIncident !== null && liveIncident !== '') {
      return liveIncident;
    }
    return null;
  }

  onRaspberryPiTabClick() {
    this.selectTab('raspberry-pi');
  }

  stopRaspberryPiPolling(): void {
    if (this.raspberryPiPollTimer) {
      clearTimeout(this.raspberryPiPollTimer);
      this.raspberryPiPollTimer = null;
    }
  }

  private scheduleNextRaspberryPiPoll(): void {
    this.stopRaspberryPiPolling();
    if (this.activeTab === 'raspberry-pi' || this.showRaspberryPiLayer) {
      this.raspberryPiPollTimer = setTimeout(() => {
        if (this.activeTab === 'raspberry-pi' || this.showRaspberryPiLayer) {
          if (this.currentRaspberryPiSensorUuids && this.currentRaspberryPiSensorUuids.length > 0) {
            this.fetchBleWifiDevicesByUuids(this.currentRaspberryPiSensorUuids, true, this.raspberryPiPage);
          } else {
            this.fetchRaspberryPiDevices();
          }
        }
      }, 10000); // Poll every 10 seconds
    }
  }

  private resolveSensorUuid(sensor: any): Observable<string | null> {
    if (sensor?.raspberryPi?.uuid) {
      return of(sensor.raspberryPi.uuid);
    }
    if (sensor?.uuid) {
      return of(sensor.uuid);
    }
    if (sensor?.raspberryPiId) {
      return this.dataService.getRaspberryPi(sensor.raspberryPiId).pipe(
        map((rpiData: any) => {
          sensor.raspberryPi = rpiData;
          return rpiData?.uuid || null;
        }),
        catchError((err: any) => {
          console.error('Error fetching Raspberry Pi by ID:', sensor.raspberryPiId, err);
          return of(null);
        })
      );
    }
    if (sensor?.id) {
      return this.dataService.findRaspberryPi({ where: { sensorId: sensor.id } }).pipe(
        switchMap((rpiResult: any) => {
          const foundRpi = rpiResult?.rows?.find((r: any) => r.sensorId?.toString() === sensor.id?.toString()) || rpiResult?.rows?.[0];
          if (foundRpi && foundRpi.uuid) {
            sensor.raspberryPiId = foundRpi.id;
            sensor.raspberryPi = foundRpi;
            return of(foundRpi.uuid);
          } else if (foundRpi && foundRpi.id) {
            sensor.raspberryPiId = foundRpi.id;
            return this.dataService.getRaspberryPi(foundRpi.id).pipe(
              map((rpiData: any) => {
                sensor.raspberryPi = rpiData;
                return rpiData?.uuid || null;
              }),
              catchError(() => of(null))
            );
          }
          return of(null);
        }),
        catchError((err: any) => {
          console.error('Error finding Raspberry Pi for sensor ID:', sensor.id, err);
          return of(null);
        })
      );
    }
    return of(null);
  }

  private getRaspberryPiSensorsForFloor(results: any): any[] {
    const rpiList = results?.raspberryPiList || [];
    if (!rpiList.length) return [];

    const floorPerimeterId = this.floorMapEntity?.perimeterId || this.floorMapEntity?.arcAngelId || this.floorMapEntity?.id;
    const building = this.floorMapEntity?.building ?? (typeof this.floorMapEntity?.getParentBuilding === 'function' ? this.floorMapEntity.getParentBuilding() : null);
    const buildingPerimeterId = building?.perimeterId || building?.id;

    if (buildingPerimeterId && floorPerimeterId && Array.isArray(results.buildings)) {
      const bldg = results.buildings.find((b: any) => b.id && parseInt(b.id) === parseInt(buildingPerimeterId));
      const floor = (bldg?.floors || []).find((f: any) => parseInt(f.id) === parseInt(floorPerimeterId));
      if (floor) {
        const floorSensors = rpiList.filter((s: any) =>
          (floor.descendants && floor.descendants.includes(s.perimeterId)) ||
          s.perimeterId === floor.id
        );
        if (floorSensors.length > 0) {
          return floorSensors;
        }
      }
    }

    if (floorPerimeterId) {
      const matched = rpiList.filter((s: any) => String(s.perimeterId) === String(floorPerimeterId));
      if (matched.length > 0) {
        return matched;
      }
    }

    return rpiList;
  }

  fetchRaspberryPiDevices() {
    this.raspberryPiPage = 1;
    if (this.raspberryPiListForFloor && this.raspberryPiListForFloor.length > 0) {
      this.raspberryPiLoading = this.raspberryPiDevices.length === 0;
      const observables = this.raspberryPiListForFloor.map((sensor: any) =>
        this.resolveSensorUuid(sensor).pipe(
          map(uuid => {
            if (uuid) {
              sensor.uuid = uuid;
            }
            return uuid;
          })
        )
      );
      forkJoin(observables).subscribe({
        next: (uuids: (string | null)[]) => {
          const uniqueUuids = Array.from(new Set(uuids.filter((u): u is string => !!u && typeof u === 'string' && u.trim().length > 0)));
          this.currentRaspberryPiSensorUuids = uniqueUuids;
          if (uniqueUuids.length > 0) {
            this.fetchBleWifiDevicesByUuids(uniqueUuids, false, 1);
          } else {
            this.raspberryPiLoading = false;
            this.raspberryPiDevices = [];
            this.raspberryPiTotal = 0;
            this.raspberryPiTotalPages = 1;
            this.stopRaspberryPiPolling();
            this.cdr.detectChanges();
          }
        },
        error: (err: any) => {
          this.raspberryPiLoading = false;
          console.error('Error resolving Raspberry Pi sensor UUIDs:', err);
          this.cdr.detectChanges();
        }
      });
    } else {
      this.raspberryPiLoading = this.raspberryPiDevices.length === 0;
      this.dataService.getSensorList().subscribe({
        next: (results: any) => {
          const sensors = this.getRaspberryPiSensorsForFloor(results);
          if (!sensors || sensors.length === 0) {
            this.raspberryPiLoading = false;
            this.raspberryPiDevices = [];
            this.raspberryPiTotal = 0;
            this.raspberryPiTotalPages = 1;
            this.currentRaspberryPiSensorUuids = [];
            this.stopRaspberryPiPolling();
            this.cdr.detectChanges();
            return;
          }
          const observables = sensors.map((sensor: any) =>
            this.resolveSensorUuid(sensor).pipe(
              map(uuid => {
                if (uuid) {
                  sensor.uuid = uuid;
                }
                return uuid;
              })
            )
          );
          forkJoin(observables).subscribe({
            next: (uuids: (string | null)[]) => {
              const uniqueUuids = Array.from(new Set(uuids.filter((u): u is string => !!u && typeof u === 'string' && u.trim().length > 0)));
              this.currentRaspberryPiSensorUuids = uniqueUuids;
              if (uniqueUuids.length > 0) {
                this.fetchBleWifiDevicesByUuids(uniqueUuids, false, 1);
              } else {
                this.raspberryPiLoading = false;
                this.raspberryPiDevices = [];
                this.raspberryPiTotal = 0;
                this.raspberryPiTotalPages = 1;
                this.stopRaspberryPiPolling();
                this.cdr.detectChanges();
              }
            },
            error: (err: any) => {
              this.raspberryPiLoading = false;
              console.error('Error resolving Raspberry Pi UUIDs from sensor list:', err);
              this.cdr.detectChanges();
            }
          });
        },
        error: (err: any) => {
          this.raspberryPiLoading = false;
          console.error('Error fetching sensor list for Raspberry Pi:', err);
          this.cdr.detectChanges();
        }
      });
    }
  }

  fetchBleWifiDevicesByUuids(sensorUuids: string[], isBackgroundPoll: boolean = false, page: number = 1) {
    if (!sensorUuids || sensorUuids.length === 0) {
      this.raspberryPiLoading = false;
      this.raspberryPiDevices = [];
      this.raspberryPiTotal = 0;
      this.raspberryPiTotalPages = 1;
      this.cdr.detectChanges();
      return;
    }

    if (!isBackgroundPoll) {
      this.raspberryPiLoading = true;
    }

    this.raspberryPiPage = page;

    const timeBounds = this.getTimeRangeBounds();

    // Trigger transport count queries immediately in parallel with device list query on page 1
    if (page === 1) {
      this.fetchTransportCounts(sensorUuids, timeBounds);
    }
    this.fetchSensorCounts(sensorUuids, timeBounds);

    const payload: BleWifiQueryRequest = {
      sensor_uuid: sensorUuids,
      page: page,
      limit: this.raspberryPiLimit
    };

    if (this.selectedTransportFilter && this.selectedTransportFilter !== 'ALL') {
      payload.transport = this.selectedTransportFilter.toUpperCase() === 'WIFI' ? 'WIFI' : this.selectedTransportFilter;
    }

    if (timeBounds.from && timeBounds.to) {
      payload.last_seen_from = timeBounds.from;
      payload.last_seen_to = timeBounds.to;
      payload.first_seen_from = timeBounds.from;
    }

    this.dataService.queryBleWifiDevices(payload).subscribe({
      next: (res: any) => {
        this.raspberryPiLoading = false;
        this.raspberryPiResponse = res;
        let records: any[] = [];
        if (res && res.data && Array.isArray(res.data.records)) {
          records = res.data.records;
          this.raspberryPiTotal = res.data.total !== undefined ? res.data.total : records.length;
          this.raspberryPiLimit = res.data.limit ?? this.raspberryPiLimit;
          this.raspberryPiPage = res.data.page ?? page;
          this.raspberryPiTotalPages = Math.max(1, Math.ceil(this.raspberryPiTotal / this.raspberryPiLimit));
        } else if (res && res.data && Array.isArray(res.data)) {
          records = res.data;
          this.raspberryPiTotal = res.total !== undefined ? res.total : records.length;
          this.raspberryPiTotalPages = 1;
        } else if (Array.isArray(res)) {
          records = res;
          this.raspberryPiTotal = records.length;
          this.raspberryPiTotalPages = 1;
        } else if (res && Array.isArray(res.records)) {
          records = res.records;
          this.raspberryPiTotal = res.total !== undefined ? res.total : records.length;
          this.raspberryPiTotalPages = 1;
        } else {
          this.raspberryPiTotal = res?.total !== undefined ? res.total : (res?.data?.total !== undefined ? res.data.total : 0);
          this.raspberryPiTotalPages = 1;
        }

        const currentFilter = (this.selectedTransportFilter || 'ALL').toUpperCase();
        if (currentFilter === 'ALL') {
          this.raspberryPiTotalCount = this.raspberryPiTotal;
          if (this.raspberryPiBleCount > 0 && this.raspberryPiWifiCount === 0 && this.raspberryPiTotal >= this.raspberryPiBleCount) {
            this.raspberryPiWifiCount = this.raspberryPiTotal - this.raspberryPiBleCount;
          } else if (this.raspberryPiWifiCount > 0 && this.raspberryPiBleCount === 0 && this.raspberryPiTotal >= this.raspberryPiWifiCount) {
            this.raspberryPiBleCount = this.raspberryPiTotal - this.raspberryPiWifiCount;
          }
        } else if (currentFilter === 'BLE') {
          this.raspberryPiBleCount = this.raspberryPiTotal;
          if (this.raspberryPiTotalCount > this.raspberryPiBleCount && this.raspberryPiWifiCount === 0) {
            this.raspberryPiWifiCount = this.raspberryPiTotalCount - this.raspberryPiBleCount;
          }
        } else if (currentFilter === 'WIFI') {
          this.raspberryPiWifiCount = this.raspberryPiTotal;
          if (this.raspberryPiTotalCount > this.raspberryPiWifiCount && this.raspberryPiBleCount === 0) {
            this.raspberryPiBleCount = this.raspberryPiTotalCount - this.raspberryPiWifiCount;
          }
        }

        this.raspberryPiDevices = records.map((d: any) => ({
          ...d,
          device_name: d.device_name || d.name || 'Unknown Device',
          name: d.name || d.device_name || 'Unknown Device',
          address: d.address || d.advertisedMac || d.resolvedMac || 'N/A',
          platform: d.platform || 'Other',
          transport: d.transport || d.serviceType || 'BLE',
          rssi: d.rssi,
          manufacturer_id: d.manufacturer_id || d.manufacturerId || '',
          manufacturerId: d.manufacturerId || d.manufacturer_id || '',
          last_seen: d.last_seen || d.lastSeen || d.updatedAt || d.createdAt,
          lastSeen: d.lastSeen || d.last_seen || d.updatedAt || d.createdAt
        }));

        this.updateTotalCount();
        this.cdr.detectChanges();
        this.scheduleNextRaspberryPiPoll();
      },
      error: (err: any) => {
        this.raspberryPiLoading = false;
        console.error('Error fetching BLE/WiFi devices for sensor UUIDs:', sensorUuids, err);
        this.cdr.detectChanges();
        if (this.activeTab === 'raspberry-pi' || this.showRaspberryPiLayer) {
          this.scheduleNextRaspberryPiPoll();
        }
      }
    });
  }

  getTimeRangeBounds(): { from?: string; to?: string; first_seen?: string; last_seen?: string } {
    if (!this.selectedTimeRange || this.selectedTimeRange === 'all') {
      return {};
    }
    const now = new Date();
    let minutes = 5;
    if (this.selectedTimeRange === '10min') {
      minutes = 10;
    } else if (this.selectedTimeRange === '30min') {
      minutes = 30;
    } else if (this.selectedTimeRange === '1hour') {
      minutes = 60;
    }
    const fromDate = new Date(now.getTime() - minutes * 60 * 1000);
    return {
      from: fromDate.toISOString(),
      to: now.toISOString(),
      first_seen: fromDate.toISOString(),
      last_seen: now.toISOString()
    };
  }

  onSelectTimeRange(range: string): void {
    this.selectedTimeRange = range;
    this.raspberryPiPage = 1;
    this.fetchBleWifiDevicesByUuids(this.currentRaspberryPiSensorUuids, false, 1);
  }

  private extractTotalFromResponse(res: any): number | null {
    if (res?.data?.total !== undefined && res?.data?.total !== null) {
      return Number(res.data.total);
    }
    if (res?.total !== undefined && res?.total !== null) {
      return Number(res.total);
    }
    if (Array.isArray(res?.data?.records)) {
      return res.data.records.length;
    }
    if (Array.isArray(res?.records)) {
      return res.records.length;
    }
    if (Array.isArray(res?.data)) {
      return res.data.length;
    }
    if (Array.isArray(res)) {
      return res.length;
    }
    return null;
  }

  private updateTotalCount(): void {
    if (this.raspberryPiBleCount > 0 && this.raspberryPiWifiCount > 0) {
      this.raspberryPiTotalCount = this.raspberryPiBleCount + this.raspberryPiWifiCount;
      if ((this.selectedTransportFilter || 'ALL').toUpperCase() === 'ALL') {
        this.raspberryPiTotal = this.raspberryPiTotalCount;
      }
    } else if (this.raspberryPiTotal > 0 && (this.selectedTransportFilter || 'ALL').toUpperCase() === 'ALL') {
      this.raspberryPiTotalCount = this.raspberryPiTotal;
    }
  }

  fetchTransportCounts(sensorUuids: string[], timeBounds?: { from?: string; to?: string; first_seen?: string; last_seen?: string }): void {
    if (!sensorUuids || sensorUuids.length === 0) return;

    // Cancel in-flight count queries before launching new ones
    this.transportCountSubs.forEach(s => s.unsubscribe());
    this.transportCountSubs = [];

    const bounds = timeBounds || this.getTimeRangeBounds();
    const basePayload: BleWifiQueryRequest = {
      sensor_uuid: sensorUuids,
      limit: 1
    };
    if (bounds.from && bounds.to) {
      basePayload.last_seen_from = bounds.from;
      basePayload.last_seen_to = bounds.to;
      basePayload.first_seen_from = bounds.from;
    }

    const currentFilter = (this.selectedTransportFilter || 'ALL').toUpperCase();

    // Query BLE devices count
    const bleSub = this.dataService.queryBleWifiDevices({ ...basePayload, transport: 'BLE' }).subscribe({
      next: (res: any) => {
        const total = this.extractTotalFromResponse(res);
        if (total !== null) {
          this.raspberryPiBleCount = total;
          if (this.raspberryPiTotal > 0 && this.raspberryPiTotal >= total) {
            if (this.raspberryPiWifiCount === 0 || currentFilter === 'ALL') {
              this.raspberryPiWifiCount = this.raspberryPiTotal - total;
            }
          }
          this.updateTotalCount();
          this.cdr.detectChanges();
        }
      },
      error: (err: any) => console.error('Error querying BLE count:', err)
    });
    this.transportCountSubs.push(bleSub);

    // Query WiFi devices count
    const wifiSub = this.dataService.queryBleWifiDevices({ ...basePayload, transport: 'WIFI' }).subscribe({
      next: (res: any) => {
        const total = this.extractTotalFromResponse(res);
        if (total !== null) {
          this.raspberryPiWifiCount = total;
          if (this.raspberryPiTotal > 0 && this.raspberryPiTotal >= total) {
            if (this.raspberryPiBleCount === 0 || currentFilter === 'ALL') {
              this.raspberryPiBleCount = this.raspberryPiTotal - total;
            }
          }
          this.updateTotalCount();
          this.cdr.detectChanges();
        }
      },
      error: (err: any) => console.error('Error querying WiFi count:', err)
    });
    this.transportCountSubs.push(wifiSub);
  }

  fetchSensorCounts(sensorUuids: string[], timeBounds?: { from?: string; to?: string; first_seen?: string; last_seen?: string }): void {
    if (!sensorUuids || sensorUuids.length === 0) return;

    this.sensorCountSubs.forEach(s => s.unsubscribe());
    this.sensorCountSubs = [];

    const bounds = timeBounds || this.getTimeRangeBounds();
    const currentTransport = (this.selectedTransportFilter || 'ALL').toUpperCase();

    // If there is only 1 sensor on the floor, its count directly equals raspberryPiTotal / raspberryPiTotalCount
    if (sensorUuids.length === 1) {
      const singleUuid = sensorUuids[0];
      const count = this.raspberryPiTotalCount || this.raspberryPiTotal || 0;
      if (count > 0 || !this.raspberryPiLoading) {
        this.raspberryPiSensorCounts = {
          ...this.raspberryPiSensorCounts,
          [singleUuid]: count
        };
        this.mapSensorCountsToIdentifiers();
      }
    }

    sensorUuids.forEach(uuid => {
      const payload: BleWifiQueryRequest = {
        sensor_uuid: [uuid],
        limit: 1
      };
      if (currentTransport !== 'ALL') {
        payload.transport = currentTransport === 'WIFI' ? 'WIFI' : currentTransport;
      }
      if (bounds.from && bounds.to) {
        payload.last_seen_from = bounds.from;
        payload.last_seen_to = bounds.to;
        payload.first_seen_from = bounds.from;
      }

      const sub = this.dataService.queryBleWifiDevices(payload).subscribe({
        next: (res: any) => {
          const total = this.extractTotalFromResponse(res);
          if (total !== null) {
            this.raspberryPiSensorCounts = {
              ...this.raspberryPiSensorCounts,
              [uuid]: total
            };
            this.mapSensorCountsToIdentifiers();
            this.cdr.detectChanges();
          }
        },
        error: (err: any) => console.error(`Error querying count for sensor UUID ${uuid}:`, err)
      });
      this.sensorCountSubs.push(sub);
    });
  }

  private mapSensorCountsToIdentifiers(): void {
    const sensors = (this.raspberryPiListForFloor && this.raspberryPiListForFloor.length > 0)
      ? this.raspberryPiListForFloor
      : [];

    const newCounts = { ...this.raspberryPiSensorCounts };

    sensors.forEach((s: any) => {
      const uuid = s?.raspberryPi?.uuid || s?.uuid || s?.sensorUuid;
      let count: number | undefined = undefined;
      if (uuid) {
        if (newCounts[uuid] !== undefined) {
          count = newCounts[uuid];
        } else {
          const lowerUuid = uuid.toLowerCase();
          const matchKey = Object.keys(newCounts).find(k => k.toLowerCase() === lowerUuid);
          if (matchKey && newCounts[matchKey] !== undefined) {
            count = newCounts[matchKey];
          }
        }
      }

      if (count !== undefined) {
        if (s.id != null) {
          newCounts[String(s.id)] = count;
        }
        if (s.raspberryPiId != null) {
          newCounts[String(s.raspberryPiId)] = count;
        }
        if (s.perimeterId != null) {
          newCounts[String(s.perimeterId)] = count;
        }
      }
    });

    this.raspberryPiSensorCounts = newCounts;
  }

  onSelectTransportFilter(transport: string): void {
    if (this.selectedTransportFilter === transport) return;
    this.selectedTransportFilter = transport;
    this.raspberryPiPage = 1;
    this.fetchBleWifiDevicesByUuids(this.currentRaspberryPiSensorUuids, false, 1);
  }

  getAllTransportCount(): number {
    if (this.raspberryPiBleCount > 0 && this.raspberryPiWifiCount > 0) {
      return this.raspberryPiBleCount + this.raspberryPiWifiCount;
    }
    if (this.raspberryPiTotalCount > 0) {
      return this.raspberryPiTotalCount;
    }
    const currentFilter = (this.selectedTransportFilter || 'ALL').toUpperCase();
    if (currentFilter === 'ALL' && this.raspberryPiTotal > 0) {
      return this.raspberryPiTotal;
    }
    if (this.raspberryPiBleCount > 0 || this.raspberryPiWifiCount > 0) {
      return this.raspberryPiBleCount + this.raspberryPiWifiCount;
    }
    return this.raspberryPiTotal || (this.raspberryPiDevices ? this.raspberryPiDevices.length : 0);
  }

  getTransportCount(transport: string): number {
    const target = (transport || '').toUpperCase();
    const currentFilter = (this.selectedTransportFilter || 'ALL').toUpperCase();

    if (target === 'BLE') {
      if (this.raspberryPiBleCount > 0) {
        return this.raspberryPiBleCount;
      }
      if (currentFilter === 'BLE' && this.raspberryPiTotal > 0) {
        return this.raspberryPiTotal;
      }
      if (this.raspberryPiTotal > 0 && this.raspberryPiWifiCount > 0 && this.raspberryPiTotal >= this.raspberryPiWifiCount) {
        return this.raspberryPiTotal - this.raspberryPiWifiCount;
      }
      if (this.raspberryPiDevices && this.raspberryPiDevices.length > 0) {
        return this.raspberryPiDevices.filter((d: any) => (d?.transport || d?.serviceType || '').toUpperCase().includes('BLE')).length;
      }
      return 0;
    }

    if (target.includes('WIFI')) {
      if (this.raspberryPiWifiCount > 0) {
        return this.raspberryPiWifiCount;
      }
      if ((currentFilter === 'WIFI' || currentFilter === 'WIFI-DEVICES') && this.raspberryPiTotal > 0) {
        return this.raspberryPiTotal;
      }
      if (this.raspberryPiTotal > 0 && this.raspberryPiBleCount > 0 && this.raspberryPiTotal >= this.raspberryPiBleCount) {
        return this.raspberryPiTotal - this.raspberryPiBleCount;
      }
      if (this.raspberryPiDevices && this.raspberryPiDevices.length > 0) {
        return this.raspberryPiDevices.filter((d: any) => (d?.transport || d?.serviceType || '').toUpperCase().includes('WIFI')).length;
      }
      return 0;
    }

    if (!this.raspberryPiDevices) return 0;
    return this.raspberryPiDevices.filter((d: any) => {
      const t = (d?.transport || d?.serviceType || '').toUpperCase();
      return t.includes(target);
    }).length;
  }

  isAllFilterSelected(): boolean {
    const transport = (this.selectedTransportFilter || 'ALL').toUpperCase();
    const platform = (this.selectedPlatformFilter || 'ALL').toUpperCase();
    return transport === 'ALL' && platform === 'ALL';
  }

  getActiveCountBadgeText(): string {
    const totalAll = this.getAllTransportCount();
    const hasSearch = !!(this.raspberryPiSearchQuery && this.raspberryPiSearchQuery.trim());
    const isFiltered = !this.isAllFilterSelected() || hasSearch;

    if (!isFiltered) {
      return `${totalAll.toLocaleString()} Active`;
    }

    if (hasSearch || this.selectedPlatformFilter !== 'ALL') {
      const filteredCount = this.getFilteredRaspberryPiDevices().length;
      return `${filteredCount.toLocaleString()} of ${totalAll.toLocaleString()} Active`;
    }

    // Transport filter active (BLE or WiFi)
    const currentCount = this.raspberryPiTotal || this.getFilteredRaspberryPiDevices().length;
    return `${currentCount.toLocaleString()} of ${totalAll.toLocaleString()} Active`;
  }

  clearRaspberryPiFilters(): void {
    this.raspberryPiSearchQuery = '';
    this.selectedPlatformFilter = 'ALL';
    this.selectedTimeRange = '5min';
    this.selectedTransportFilter = 'ALL';
    this.raspberryPiPage = 1;
    this.fetchBleWifiDevicesByUuids(this.currentRaspberryPiSensorUuids, false, 1);
  }

  raspberryPiPrevPage(): void {
    if (this.raspberryPiPage > 1) {
      this.fetchBleWifiDevicesByUuids(this.currentRaspberryPiSensorUuids, false, this.raspberryPiPage - 1);
    }
  }

  raspberryPiNextPage(): void {
    if (this.raspberryPiPage < this.raspberryPiTotalPages) {
      this.fetchBleWifiDevicesByUuids(this.currentRaspberryPiSensorUuids, false, this.raspberryPiPage + 1);
    }
  }

  getDistinctOtherTransports(): string[] {
    if (!this.raspberryPiDevices) return [];
    const transports = new Set<string>();
    this.raspberryPiDevices.forEach((d: any) => {
      const t = (d?.transport || d?.serviceType || '').trim().toUpperCase();
      if (t && t !== 'BLE' && t !== 'WIFI' && t !== 'ALL') {
        transports.add(t);
      }
    });
    return Array.from(transports);
  }

  getDistinctOtherPlatforms(): string[] {
    if (!this.raspberryPiDevices) return [];
    const platforms = new Set<string>();
    this.raspberryPiDevices.forEach((d: any) => {
      const p = (d?.platform || '').trim();
      const pLower = p.toLowerCase();
      if (p && pLower !== 'ios' && pLower !== 'android' && pLower !== 'all') {
        platforms.add(p);
      }
    });
    return Array.from(platforms);
  }

  getFilteredRaspberryPiDevices(): any[] {
    let list = this.raspberryPiDevices || [];
    if (this.selectedPlatformFilter && this.selectedPlatformFilter !== 'ALL') {
      list = list.filter((d: any) => (d?.platform || '').toLowerCase() === this.selectedPlatformFilter.toLowerCase());
    }
    const q = (this.raspberryPiSearchQuery || '').trim().toLowerCase();
    if (!q) {
      return list;
    }
    return list.filter((d: any) => {
      const name = (d?.device_name || d?.name || '').toLowerCase();
      const addr = (d?.address || '').toLowerCase();
      const plat = (d?.platform || '').toLowerCase();
      const trans = (d?.transport || d?.serviceType || '').toLowerCase();
      const mfg = (d?.manufacturer_id || d?.manufacturerId || '').toLowerCase();
      return name.includes(q) || addr.includes(q) || plat.includes(q) || trans.includes(q) || mfg.includes(q);
    });
  }

  getPlatformCount(platform: string): number {
    if (!this.raspberryPiDevices) return 0;
    return this.raspberryPiDevices.filter(
      (d: any) => (d?.platform || '').toLowerCase() === platform.toLowerCase()
    ).length;
  }

  formatLastSeen(value: any): string {
    if (!value) return 'N/A';
    try {
      const m = moment(value);
      if (!m.isValid()) return 'N/A';
      return m.format('hh:mm:ss A');
    } catch {
      return 'N/A';
    }
  }

  getDeviceAvatarClass(platform?: string, name?: string, transport?: string): string {
    const t = (transport || '').toUpperCase();
    if (t === 'BLE') {
      return 'rpi-avatar-ble';
    }
    if (t.includes('WIFI')) {
      return 'rpi-avatar-wifi';
    }
    const p = (platform || '').toLowerCase();
    const n = (name || '').toLowerCase();
    if (p === 'ios' || n.includes('apple') || n.includes('iphone') || n.includes('ipad')) {
      return 'rpi-avatar-apple';
    }
    if (p === 'android' || n.includes('android')) {
      return 'rpi-avatar-android';
    }
    if (n.includes('oppo') || n.includes('vivo') || n.includes('samsung') || n.includes('xiaomi') || n.includes('oneplus')) {
      return 'rpi-avatar-brand';
    }
    return 'rpi-avatar-generic';
  }

  getTransportBadgeClass(transport?: string): string {
    const t = (transport || '').toUpperCase();
    if (t === 'BLE') return 'badge-ble';
    if (t.includes('WIFI')) return 'badge-wifi';
    return 'badge-other';
  }

  getDeviceIconClass(platform?: string, name?: string, transport?: string): string {
    const t = (transport || '').toUpperCase();
    if (t === 'BLE') {
      return 'fa-brands fa-bluetooth-b';
    }
    if (t.includes('WIFI')) {
      return 'fa-solid fa-wifi';
    }
    const p = (platform || '').toLowerCase();
    const n = (name || '').toLowerCase();
    if (p === 'ios' || n.includes('apple') || n.includes('iphone') || n.includes('ipad')) {
      return 'fa-brands fa-apple';
    }
    if (p === 'android') {
      return 'fa-brands fa-android';
    }
    if (n.includes('phone') || n.includes('oppo') || n.includes('vivo') || n.includes('samsung') || n.includes('xiaomi')) {
      return 'fa-solid fa-mobile-screen-button';
    }
    return 'fa-solid fa-signal';
  }

  getPlatformBadgeClass(platform?: string): string {
    const p = (platform || '').toLowerCase();
    if (p === 'ios') return 'badge-ios';
    if (p === 'android') return 'badge-android';
    return 'badge-other';
  }

  getRssiBadgeClass(rssi: any): string {
    if (rssi == null || isNaN(Number(rssi))) return 'rssi-na';
    const val = Number(rssi);
    if (val >= -60) return 'rssi-excellent';
    if (val >= -75) return 'rssi-good';
    if (val >= -85) return 'rssi-fair';
    return 'rssi-poor';
  }

  onBleWifiDevicesChange(records: any[]): void {
    this.bleWifiDevicesFromTab = records || [];
    this.cdr.detectChanges();
  }

  onBleWifiDeviceSelect(device: any): void {
    this.selectedDevice = device;
    this.floorMapComponent?.focusDevice(device);
  }

  onDeviceCardClick(device: any): void {
    this.selectedDevice = device;
    this.floorMapComponent?.focusDevice(device);
  }

  onDeviceMarkerClick(device: any): void {
    this.selectedDevice = device;
    const el = document.querySelector(`[data-device-id="${device.id}"]`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  onNumberOfDevicesWithCoordsChange(count: number): void {
    this.numberOfDevicesWithCoords = count;
  }

  hasCoordinates(device: any): boolean {
    if (!device) return false;
    if (Array.isArray(device.coordinates) && device.coordinates.length >= 2) {
      return !isNaN(Number(device.coordinates[0])) && !isNaN(Number(device.coordinates[1]));
    }
    return (device.latitude != null && device.longitude != null) ||
           (device.lat != null && device.lng != null) ||
           (device.position?.coordinates && device.position.coordinates.length >= 2);
  }

  getEffectiveDevicesForMap(): any[] {
    if (this.activeTab === 'devices' && this.bleWifiDevicesFromTab && this.bleWifiDevicesFromTab.length > 0) {
      return this.bleWifiDevicesFromTab;
    }
    return this.raspberryPiDevices || [];
  }

  showHideBeaconLayer() {
    /* ... */
  }
  sendMessageForFloor() {
    let incidentId: string | undefined;
    if (this.enableInteraction) {
      incidentId = this.liveData.eventId;
    } else if (this.floorMapEntity?.incidents && this.floorMapEntity.incidents.length > 0) {
      incidentId = this.floorMapEntity.incidents[0].eventId;
    }
    if (!incidentId) {
      return;
    }

    const statuses = ['DANGER', 'SAFE', 'UNKNOWN'];
    const perimeterId = this.floorMapEntity?.perimeterId;
    const recipients = `users on ${this.floorMapEntity?.name} with status of ${statuses.join(', ')} (total ${this.data.totalUserCount})`;

    const options = {
      useApi: true,
      statuses,
      perimeterId,
      incidentId,
      recipients
    };

    this.openMultipleMessageModalWithOptions('Send Message', options);
  }
  private openMultipleMessageModalWithOptions(title: string, options: any, showCancel: boolean = false) {
    if (!options || !options.statuses || options.statuses.length === 0) {
      const modalRef = this.openModalA11y(this.noUsersModal, {
        centered: true,
        backdrop: 'static'
      });
      modalRef.componentInstance.message = 'No users to notify';
      return;
    }

    const modalRef = this.openModalA11y(MultipleMessageComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.options = options;
    modalRef.componentInstance.showCancel = showCancel;

    return modalRef.result;
  }
  toggle3DUserClusters() {
    this.data.show3DUserClusters = !this.data.show3DUserClusters;
  }

  statusChanged() {
    const checkedStatuses: string[] = [];

    if (this.data.dangerChecked) checkedStatuses.push('DANGER');
    if (this.data.safeChecked) checkedStatuses.push('SAFE');
    if (this.data.unknownChecked) checkedStatuses.push('UNKNOWN');
    if (this.data.suspectChecked) checkedStatuses.push('SUSPECT');

    // Set flag to prevent userOnFloorsChange from overwriting
    // Filter is active when 0-3 checkboxes are checked (not all 4)
    this.isStatusFilterActive = checkedStatuses.length < 4;

    let filteredUsers: User[] = [];

    // If nothing selected → show NOTHING
    if (checkedStatuses.length > 0) {
      filteredUsers = this.fullUsers.filter(user =>
        checkedStatuses.includes(user.status)
      );
    }

    // Distribute into 3 columns
    const totalUsers = filteredUsers.length;
    const col1End = Math.ceil(totalUsers / 3);
    const col2End = Math.ceil((totalUsers * 2) / 3);

    this.data.userList1 = filteredUsers.slice(0, col1End);
    this.data.userList2 = filteredUsers.slice(col1End, col2End);
    this.data.userList3 = filteredUsers.slice(col2End);

    // Restore visibility state after status filter
    this.restoreUserVisibility();

    this.data.totalUserCount = filteredUsers.length;
    this.data.lastPage = Math.max(1, Math.ceil(filteredUsers.length / this.data.limit));
    this.data.page = 1;

    this.cdr.detectChanges();
  }

  sendMessageToUsers(status: string) {
    let incidentId: string | undefined;
    if (this.enableInteraction && this.liveData) {
      incidentId = this.liveData.eventId;
    } else if (this.floorMapEntity?.incidents && this.floorMapEntity.incidents.length > 0) {
      incidentId = this.floorMapEntity.incidents[0].eventId;
    }
    if (!incidentId) {
      return;
    }

    let totalUsers = 0;
    if (status === 'DANGER') totalUsers = this.data.dangerCount;
    if (status === 'SAFE') totalUsers = this.data.safeCount;
    if (status === 'UNKNOWN') totalUsers = this.data.unknownCount;
    if (status === 'SUSPECT') totalUsers = this.data.suspectCount;

    if (totalUsers === 0) {
      const modalRef = this.openModalA11y(ResponseModalComponent, {
        centered: true,
        backdrop: 'static'
      });
      modalRef.componentInstance.message = 'No user to contact';
      return;
    }

    const statuses = [status];
    const perimeterId = this.floorMapEntity?.perimeterId;
    const recipients = `users on ${this.floorMapEntity?.name} with status of ${statuses.join(', ')} (total ${totalUsers})`;

    const options = {
      useApi: true,
      statuses,
      perimeterId,
      incidentId,
      recipients
    };

    this.openMultipleMessageModalWithOptions('Send Message', options);
  }
  jumpPage(direction: number): void {
    this.data.page += direction;
    // Ensure page stays within bounds
    if (this.data.page < 1) {
      this.data.page = 1;
    }
    if (this.data.page > this.data.lastPage) {
      this.data.page = this.data.lastPage;
    }

    this.updateUserListsForPage(); // Update lists based on new page
  }

  toggleUserVisibility(user: User) {
    if (user.visible) {
      this.removeUser(user);
    } else {
      this.showUser(user);
    }
    user.visible = !user.visible;
    // Save visibility state to preserve across data refreshes
    if (user.deviceId) {
      this.userVisibilityMap.set(user.deviceId, user.visible);
    }
  }

  private restoreUserVisibility(): void {
    // Restore visibility state for all user lists
    const allLists = [this.data.userList1, this.data.userList2, this.data.userList3];
    allLists.forEach(list => {
      list.forEach(user => {
        if (user.deviceId && this.userVisibilityMap.has(user.deviceId)) {
          user.visible = this.userVisibilityMap.get(user.deviceId) ?? true;
        }
      });
    });
  }
  showUser(user: any) {
    const incident = this.liveData;
    if (!incident) return;
    const entity = this.dataContext.getDevicemapEntityByDeviceId(user.deviceId);
    if (!entity) {
      let time;
      // If playback, set time as needed
      if (this.enablePlayback) {
        // let timestamp = Math.floor(this.coreService.getCurrentTime() / 1000) * 1000;
        // time = moment(timestamp).toISOString();
      }
      this.createIncidentDeviceMapEntity(user, incident, time);
      return;
    }
  }
  getDeviceMapEntityById(deviceId: string): any {
    if (this.liveData?.devices?.[deviceId]) {
      return this.liveData?.devices?.[deviceId];
    } else if (this.liveData?.building?.incidents?.[0]?.devices?.[deviceId]) {
      return this.liveData.building.incidents[0].devices[deviceId];
    }
    return undefined;
  }
  removeUser(user: any) {
    const entity = this.dataContext.getDevicemapEntityByDeviceId(user.deviceId);
    if (entity) {
    }
  }
  createIncidentDeviceMapEntity(user: any, incident: any, time?: string): void {
    let api$: Observable<any>;
    if (this.enablePlayback) {
      // api$ = this.deviceService.getIncidentDeviceHistoryDataByDeviceId(user, incident, time);
      api$ = this.deviceService.getIncidentDeviceDataByDeviceId(user, incident);
    } else {
      api$ = this.deviceService.getIncidentDeviceDataByDeviceId(user, incident);
    }
    api$.subscribe({
      next: () => {
        // Device entity created/updated
      },
      error: (error) => {
        console.error('Error creating/updating device map entity:', error);
      }
    });
  }
  showUserInfo(user: any) {
    const entity = this.getDeviceMapEntityById(user.deviceId);
    if (entity) {
      this.showUsersInfoInWindow(entity);
    }
  }
  showUsersInfoInWindow(entity: any) {
    // Check if the details window for this entity is already open
    if (!this.windowService.isEntityDetailsWindowOpen(entity.getWindowId())) {
      // Open the details window (or handle click logic)
      this.globeService.handleClick(this, entity);
    }
  }
  addUpdate() {
    if (this.floorMapEntity && this.floorMapEntity.building && typeof this.floorMapEntity.building.initViewPosLon === 'number' && typeof this.floorMapEntity.building.initViewPosLat === 'number') {
      const range = 300;
      const offset = new Cesium.HeadingPitchRange(
        this.floorMapEntity.building.initViewHeading,
        this.floorMapEntity.building.initViewPitch,
        range
      );
      const viewer = this.core.getViewer();
      viewer.camera.flyToBoundingSphere(
        new Cesium.BoundingSphere(
          Cesium.Cartesian3.fromDegrees(
            this.floorMapEntity.building.initViewPosLon,
            this.floorMapEntity.building.initViewPosLat,
            1
          )
        ),
        { duration: 0, offset }
      );
    }

    this.showGlobeClick = true;
    this.toggleUIVisibility(true);
    this.pluginContext.addGlobeClickListener(
      'incidentattributevisualizerOnClick',
      this.updateGlobeClick.bind(this)
    );
  }

  onGlobeClickClose() {
    this.pluginContext.removeGlobeClickListener('incidentattributevisualizerOnClick');
    this.showGlobeClick = false;
    this.toggleUIVisibility(false);
  }
  private toggleUIVisibility(hide: boolean) {
    const selectors = ['.details-window', '.right-panel', '.left-panel'];
    selectors.forEach((sel) => {
      Array.from(document.querySelectorAll(sel)).forEach((el: any) => {
        try {
          if (hide) {
            this.renderer.setStyle(el, 'display', 'none');
          } else {
            // details-window should be block; left/right panels should be flex
            if (sel === '.details-window') {
              this.renderer.setStyle(el, 'display', 'block');
            } else {
              this.renderer.setStyle(el, 'display', 'flex');
            }
          }
        } catch (e) {
          // ignore DOM errors
        }
      });
    });
  }
  updateGlobeClick(lat: number, lon: number) {
    const data: any = {};
    const sessionOption = this.sessionOptionService.getSessionData();
    if (sessionOption) {
      if (sessionOption.eventId) {
        data.eventId = sessionOption.eventId;
      } else if (sessionOption.event) {
        const ev = sessionOption.event;
        if (ev.eventId) {
          data.eventId = ev.eventId;
        } else if (ev.incidentId) {
          data.eventId = ev.incidentId;
        } else if (typeof ev.getEventId === 'function') {
          data.eventId = ev.getEventId();
        } else if (ev.id) {
          data.eventId = ev.id;
        }
      }
    }
    data.isInsideBuilding = true;
    data.floor = this.floorMapEntity;
    data.lat = lat;
    data.lon = lon;

    // Remove globe click listener after use
    this.pluginContext.removeGlobeClickListener('incidentattributevisualizerOnClick');
    this.showGlobeClick = false;
    this.toggleUIVisibility(false);
    // Optionally fly camera to building center
    if (this.floorMapEntity && this.floorMapEntity.building && typeof this.floorMapEntity.building.initViewPosLon === 'number' && typeof this.floorMapEntity.building.initViewPosLat === 'number') {
      const range = 300;
      const offset = new Cesium.HeadingPitchRange(
        this.floorMapEntity.building.initViewHeading,
        this.floorMapEntity.building.initViewPitch,
        range
      );
      const center = Cesium.Cartesian3.fromDegrees(
        this.floorMapEntity.building.initViewPosLon,
        this.floorMapEntity.building.initViewPosLat,
        10
      );
      const viewer = this.core.getViewer();
      viewer.camera.lookAt(center, offset);
    }

    // Open the update modal
    this.openUpdateModal(data);
  }

  openUpdateModal(data: any) {
    const modalRef = this.openModalA11y(CreateUpdateDialogComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.data = data;

    const restoreUi = () => {
      try {
        this.toggleUIVisibility(false);
        this.showGlobeClick = false;
      } catch (e) {
      }
    };

    if (modalRef.result && typeof modalRef.result.finally === 'function') {
      modalRef.result.finally(restoreUi);
    } else if (modalRef.result) {
      modalRef.result.then(restoreUi).catch(restoreUi);
    }

    return modalRef.result;
  }
  showIncidentUpdateWindow(update: any) {
    /* ... */
  }
  getPerimeters() {
    return this.liveData.getPerimeters();
  };
  getNumberOfUnknownUsersForPerimeter(perimeter: Perimeter): number {
    let incidentId: string | undefined;
    if (this.floorMapEntity?.building?.incidents && this.floorMapEntity.building.incidents.length > 0) {
      incidentId = this.floorMapEntity.building.incidents[0].eventId;
    }
    if (!incidentId) return 0;

    if (this.enablePlayback) {
      return perimeter.getNumberOfUnknownUsers();
    }

    let num = 0;
    const dict = this.deviceService.data?.userStatusByIncidentDict;
    if (dict && dict[incidentId] && dict[incidentId][(perimeter as any).arcAngelId]) {
      num = dict[incidentId][(perimeter as any).arcAngelId].unknown || 0;
    }
    return num;
  }
  getNumberOfSafeUsersForPerimeter(perimeter: Perimeter): number {
    let incidentId: string | undefined;
    if (this.floorMapEntity?.building?.incidents && this.floorMapEntity.building.incidents.length > 0) {
      incidentId = this.floorMapEntity.building.incidents[0].eventId;
    }
    if (!incidentId) return 0;

    if (this.enablePlayback) {
      return perimeter.getNumberOfSafeUsers();
    }

    let num = 0;
    const dict = this.deviceService.data?.userStatusByIncidentDict;
    if (dict && dict[incidentId] && dict[incidentId][(perimeter as any).arcAngelId]) {
      num = dict[incidentId][(perimeter as any).arcAngelId].safe || 0;
    }
    return num;
  }
  getNumberOfUnSafeUsersForPerimeter(perimeter: Perimeter): number {
    let incidentId: string | undefined;
    if (this.sessionOptionService.isLiveMode()) {
      incidentId = this.sessionOptionService.getSessionData()?.eventId;
    } else if (this.floorMapEntity?.building?.incidents && this.floorMapEntity.building.incidents.length > 0) {
      incidentId = this.floorMapEntity.building.incidents[0].eventId;
    }
    if (!incidentId) return 0;

    if (this.enablePlayback) {
      return perimeter.getNumberOfUnSafeUsers();
    }

    let num = 0;
    const dict = this.deviceService.data?.userStatusByIncidentDict;
    if (dict && dict[incidentId] && dict[incidentId][(perimeter as any).arcAngelId]) {
      num = dict[incidentId][(perimeter as any).arcAngelId].danger || 0;
    }
    return num;
  }

  viewInfo(camera: any) {
    /* ... */
  }
  viewCamera(camera: any) {
    /* ... */
  }
  viewTaskStepInfo(step: any) {
    /* ... */
  }
  markTaskStepAsUncompleted(id: string) {
    /* ... */
  }
  markTaskStepAsCompleted(id: string) {
    /* ... */
  }

  close() {
    this.stopRaspberryPiPolling();
    this.floorService.toggleGrandchild(false);
    this.threeJsBuildingIntegration.clearFloorHighlight();
  }
  numberOfBeaconsChange(event: number) {
    this.numberOfBeacons = event;
  }
  numberOfCamerasChange(event: number) {
    this.numberOfCameras = event;
  }
  numberOfAccessControlsChange(event: number) {
    this.numberOfAccessControls = event;
  }
  accessControlLayerChange(accessControlList: any) {
    this.accessControlListForFloor = accessControlList;
  }
  numberOfRaspberryPisChange(event: number) {
    this.numberOfRaspberryPis = event;
  }
  raspberryPiLayerChange(raspberryPiList: any) {
    this.raspberryPiListForFloor = raspberryPiList;
    if (raspberryPiList && raspberryPiList.length > 0) {
      if (this.activeTab === 'raspberry-pi' || this.showRaspberryPiLayer) {
        this.fetchRaspberryPiDevices();
      }
    } else {
      this.currentRaspberryPiSensorUuids = [];
      this.raspberryPiDevices = [];
      this.stopRaspberryPiPolling();
      this.cdr.detectChanges();
    }
  }
  onRaspberryPiMarkerClick(sensor: any) {
    this.selectTab('raspberry-pi');
  }
  changeBeacons(event: any) {
    if (event.target.checked) {
      this.beaconsVisible = true;
    } else {
      this.beaconsVisible = false;
    }
  }
  changeAccessControl(event: any) {
    if (event.target.checked) {
      this.showAccessControlLayer = true;
    } else {
      this.showAccessControlLayer = false;
    }
  }
  changeRaspberryPi(event: any) {
    if (event.target.checked) {
      this.showRaspberryPiLayer = true;
    } else {
      this.showRaspberryPiLayer = false;
    }
  }
  changeBlenderView(event: any) {
    if (event.target.checked) {
      this.floorMapComponent?.setFloorPlanOverlayVisible(false);
      this.sidebarLeafletView = this.floorMapComponent?.getLeafletViewSnapshot() ?? null;
      this.blenderViewEnabled = true;
    } else {
      this.floorMapComponent?.setFloorPlanOverlayVisible(true);
      this.blenderViewEnabled = false;
      this.blenderViewLoading = false;
    }
    setTimeout(() => {
      this.floorMapComponent?.refreshLeafletMapSize();
      const viewer = this.getSidebarBlenderViewer();
      viewer?.refreshViewport();
    }, 150);
  }

  onBlenderRoomClicked(event: { roomId: string; floorId: string; mesh: any }) {
    if (event && event.roomId && this.glbFloorView) {
      this.glbFloorView.onBlenderRoomClicked(event);
    }
  }

  onBlenderLoadingChange(loading: boolean): void {
    this.blenderViewLoading = loading;
  }

  openFullScreenModal() {
    this.isFullScreenBlender = true;
    this.cdr.detectChanges();
    const viewer = this.getSidebarBlenderViewer();
    this.floorMapComponent?.refreshLeafletMapSize();
    viewer?.triggerResize();
    requestAnimationFrame(() => {
      this.floorMapComponent?.refreshLeafletMapSize();
      viewer?.triggerResize();
    });
    [50, 150, 300].forEach((delay) => {
      setTimeout(() => {
        this.floorMapComponent?.refreshLeafletMapSize();
        viewer?.triggerResize();
      }, delay);
    });
  }

  closeFullScreenModal() {
    this.isFullScreenBlender = false;
    this.cdr.detectChanges();
    const viewer = this.getSidebarBlenderViewer();
    this.floorMapComponent?.refreshLeafletMapSize();
    viewer?.triggerResize();
    requestAnimationFrame(() => {
      this.floorMapComponent?.refreshLeafletMapSize();
      viewer?.triggerResize();
    });
    [50, 150, 300].forEach((delay) => {
      setTimeout(() => {
        this.floorMapComponent?.refreshLeafletMapSize();
        viewer?.triggerResize();
      }, delay);
    });
  }


  changeCameraClick(event: any) {
    if (event.target.checked) {
      this.cameraVisible = true;
    } else {
      this.cameraVisible = false;
    }
  }

  onUserClicked(event: { userId: string; roomId: string; mesh: any }): void {
    let roomUserRecords: any[] = [];
    if (this.blenderLiveUserData?.byRoom && event.roomId) {
      const targetRoomId = String(event.roomId).toLowerCase();
      const matchedKey = Object.keys(this.blenderLiveUserData.byRoom).find(
        key => key.toLowerCase() === targetRoomId
      );
      if (matchedKey) {
        roomUserRecords = this.blenderLiveUserData.byRoom[matchedKey] || [];
      }
    }

    const roomUserIds = new Set(roomUserRecords.map((r: any) => String(r.userId)));
    const roomUsers = this.fullUsers.filter(u => u.userId && roomUserIds.has(String(u.userId)));
    if (roomUsers.length >= 1) {
      const modalRef = this.modalService.open(UserClusterListUiComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-class'
      });
      modalRef.componentInstance.dataIsCluster = true;
      modalRef.componentInstance.userData = roomUsers;
      modalRef.componentInstance.incidentId = this.liveData?.eventId || '';
      modalRef.componentInstance.entity = this.floorMapEntity;
      modalRef.componentInstance.floorPerimeterId = this.floorMapEntity?.perimeterId;
      modalRef.componentInstance.floorType = 'FLOOR';
      modalRef.componentInstance.incident = this.liveData;
      return;
    }

    // Find the user from the full users list (fallback)
    const user = this.fullUsers.find(u => u.userId === event.userId);
    if (user) {
      this.showUserInfo(user);
    }
  }

  userOnFloorsChange(users: any) {
    // Calculate and store the original counts from all users (before any filtering)
    // These counts should not change even when checkboxes are unchecked
    this.originalDangerCount = users.filter((u: any) => u.status === 'DANGER').length;
    this.originalSafeCount = users.filter((u: any) => u.status === 'SAFE').length;
    this.originalUnknownCount = users.filter((u: any) => u.status === 'UNKNOWN').length;
    this.originalSuspectCount = users.filter((u: any) => u.status === 'SUSPECT').length;

    // Only update the displayed counts if no filter is currently active
    // This preserves the counts when checkboxes are unchecked
    if (!this.isStatusFilterActive) {
      this.data.dangerCount = this.originalDangerCount;
      this.data.safeCount = this.originalSafeCount;
      this.data.unknownCount = this.originalUnknownCount;
      this.data.suspectCount = this.originalSuspectCount;
    }

    this.data.totalUserCount = users.length;
    this.fullUsers = users; // Store all users for pagination
    this.data.lastPage = Math.max(1, Math.ceil(this.data.totalUserCount / this.data.limit));

    this.updateUserListsForPage(); // Update lists based on current page

    // Restore visibility state from map
    this.restoreUserVisibility();

    // Save originals for restoring after search
    this.origUserList1 = [...this.data.userList1];
    this.origUserList2 = [...this.data.userList2];
    this.origUserList3 = [...this.data.userList3];

    const combined = [
      ...this.data.userList1,
      ...this.data.userList2,
      ...this.data.userList3,
    ];
    // keep both places populated to avoid regressions where code expects either
    this.data.allUsers = combined;
    this.allUsers = combined;

    // If a search is active, reapply the filter so UI stays consistent
    if (this.searchQuery && this.searchQuery.length > 0) {
      this.applyFilteredToColumns();
    }
  }

  onFloorUserDevicesRaw(devices: any[]): void {
    if (!devices || !devices.length) {
      // API returned 0 users: clear blender data so the 3D viewer resets room colors/clusters.
      this.lastFloorUserDevicesRawWasEmpty = true;
      this.blenderLiveUserData = null;
      this.cdr.detectChanges();
      return;
    }
    this.lastFloorUserDevicesRawWasEmpty = false;

    const floorId = this.floorMapEntity?.perimeterId ||
      this.floorMapEntity?.arcAngelId ||
      this.floorMapEntity?.id ||
      this.floorMapEntity?.label ||
      'unknown';

    const records: any[] = [];
    const byRoom: Record<string, any[]> = {};
    const byFloor: Record<string, any[]> = {};
    const roomStatusByRoomId: Record<string, { danger: number; safe: number; unknown: number; suspect: number }> = {};

    for (const device of devices) {
      const status = (device?.status || 'UNKNOWN').toUpperCase();
      const userId = device?.userId?.toString();
      const roomId =
        device?.closestPerimeterId != null ? String(device.closestPerimeterId) :
          device?.roomId != null ? String(device.roomId) :
            device?.perimeterId != null ? String(device.perimeterId) :
              device?.id != null ? String(device.id) : '';

      const record = {
        userId,
        floorId: String(floorId),
        roomId,
        perimeterId: roomId,
        status: status.toLowerCase(),
      };

      records.push(record);

      if (roomId) {
        if (!byRoom[roomId]) {
          byRoom[roomId] = [];
        }
        byRoom[roomId].push(record);

        if (!roomStatusByRoomId[roomId]) {
          roomStatusByRoomId[roomId] = { danger: 0, safe: 0, unknown: 0, suspect: 0 };
        }
        if (status === 'DANGER') {
          roomStatusByRoomId[roomId].danger++;
        } else if (status === 'SAFE') {
          roomStatusByRoomId[roomId].safe++;
        } else if (status === 'UNKNOWN') {
          roomStatusByRoomId[roomId].unknown++;
        } else if (status === 'SUSPECT') {
          roomStatusByRoomId[roomId].suspect++;
        }
      }

      const floorKey = String(floorId);
      if (!byFloor[floorKey]) {
        byFloor[floorKey] = [];
      }
      byFloor[floorKey].push(record);
    }

    this.blenderLiveUserData = {
      records,
      byFloor,
      byRoom,
      roomStatusByRoomId,
      updatedAt: Date.now(),
    };

    this.cdr.detectChanges();
  }

  openSearchUserBox(): void {
    let incidentId: string | undefined;
    if (this.liveData) {
      incidentId = this.liveData.eventId;
    }
    if (!incidentId) {
      return;
    }

    const modalRef = this.openModalA11y(UserSearchUiComponent, {
      size: 'sm',
      backdrop: 'static',
      windowClass: 'UserSearchUiWindowShape'
    });

    modalRef.componentInstance.incidentId = incidentId;
    modalRef.componentInstance.title = 'Search User';
    modalRef.componentInstance.entity = this.liveData;

    modalRef.result.catch(() => { });
  }
  cameraLayerChange(cameraList: any) {
    // Handle the userOnFloorsChange event
    this.cameraListForFloor = cameraList;
  }
  perimeterChange(perimeter: any) {
    if (perimeter) {
      let perimeterArray: any[] = [];
      _.forEach(perimeter, (p) => {
        perimeterArray.push(p);
      });
      this.perimeters = perimeterArray;
    }
  }
  updateChanges(updates: any) {
    if (!updates) {
      this.updates = [];
      this.cdr.detectChanges();
      return;
    }

    this.updates = Array.isArray(updates) ? updates : [updates];
    this.cdr.detectChanges();
  }

  /// fetch user details from the server
  fetchProfilesFromOrganization(user: any): void {
    this.spinnerService.show();
    const title = 'User Details';
    this.organizationService
      .getProfilesFromOrganization(user.userId)
      .pipe(
        switchMap((userInfo: any) => {
          if (!userInfo) {
            return of({
              userInfo: null,
              pictureBlob: null,
              emergencyNumber: null,
              suspectDetails: null,
            });
          }
          const pictureId = userInfo?.UserPictures?.[0]?.id || null;
          const organizationId =
            userInfo?.UserOrganizations?.[0]?.Organization?.id || null;
          /// check if user is suspect
          if (user.status.toLowerCase() === 'suspect') {
            let userPhone = userInfo?.UserPhones?.[0]?.number || null;
            if (userPhone) {
              userPhone = userPhone.replace(/\D/g, '');
              if (userPhone.length > 10) {
                userPhone = userPhone.slice(-10);
              }
              return this.organizationService
                .getSuspectDetailByPhoneNumber(userPhone)
                .pipe(
                  switchMap((suspectDetails: any) => {
                    if (!pictureId) {
                      return of({
                        userInfo,
                        pictureBlob: null,
                        emergencyNumber: null,
                        suspectDetails,
                      });
                    }
                    return this.organizationService
                      .getUserPicture(pictureId)
                      .pipe(
                        catchError((error) => {
                          return of(null);
                        }),
                        map((pictureBlob) => ({
                          userInfo,
                          pictureBlob,
                          emergencyNumber: null,
                          suspectDetails,
                        }))
                      );
                  })
                );
            }
            return of({
              userInfo,
              pictureBlob: null,
              emergencyNumber: null,
              suspectDetails: null,
            });
          }

          return this.organizationService.getEmergencyNumber().pipe(
            switchMap((emergencyNumbers: any) => {
              const emergencyNumber = this.findEmergencyNumber(
                emergencyNumbers,
                organizationId
              );
              if (!pictureId) {
                return of({
                  userInfo,
                  pictureBlob: null,
                  emergencyNumber,
                  suspectDetails: null,
                });
              }
              return this.organizationService.getUserPicture(pictureId).pipe(
                catchError((error) => {
                  return of(null);
                }),
                map((pictureBlob) => ({
                  userInfo,
                  pictureBlob,
                  emergencyNumber,
                  suspectDetails: null,
                }))
              );
            })
          );
        })
      )
      .subscribe({
        next: ({ userInfo, pictureBlob, emergencyNumber, suspectDetails }) => {
          if (!userInfo) return;
          userInfo.picture = pictureBlob
            ? URL.createObjectURL(pictureBlob)
            : null;
          userInfo.emergencyNumber = emergencyNumber;
          let suspectDetail = suspectDetails || null;
          this.openDetailsModal(title, userInfo, suspectDetail, true);
          this.spinnerService.hide();
          //this.handleFlyToUserLocation(userInfo);
        },
        error: (err: any) => {
          console.error('Error fetching user data:', err);
          this.errorModal('Error', 'Failed to fetch user data.', true);
          this.spinnerService.hide();
        },
        complete: () => {
          this.spinnerService.hide();
        },
      });
  }

  // 🔹 find the emergency number from response
  private findEmergencyNumber(
    emergencyNumbers: any,
    organizationId: string | null
  ): string | null {
    if (
      emergencyNumbers &&
      Array.isArray(emergencyNumbers.rows) &&
      organizationId
    ) {
      const match = emergencyNumbers.rows.find(
        (item: any) => item.organizationId === organizationId
      );
      return match?.number || null;
    }
    return null;
  }
  private openDetailsModal(
    title: string,
    data: any,
    suspectDetails: any = null,
    shouldCallApi: boolean
  ) {
    const modalRef = this.openModalA11y(DetailsModalComponent, {
      size: 'lg',
      centered: true,
      backdrop: true,
      windowClass: 'response-modal-top zindex',
      backdropClass: 'response-modal-backdrop-top',
    });
    if (suspectDetails) {
      modalRef.componentInstance.title = 'POI Info';
      modalRef.componentInstance.suspectData = suspectDetails;
    } else {
      modalRef.componentInstance.title = title;
    }
    modalRef.componentInstance.userInfo = data;
    modalRef.componentInstance.showCancel = false;
    modalRef.componentInstance.shouldCallApi = shouldCallApi;

    return modalRef.result;
  }
  private errorModal(title: string, data: any, showCancel: boolean = false) {
    const modalRef = this.openModalA11y(DetailsModalComponent, {
      size: 'md',
      centered: true,
      backdrop: true,
      windowClass: 'response-modal-top zindex',
      backdropClass: 'response-modal-backdrop-top',
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = data;
    modalRef.componentInstance.showCancel = showCancel;

    return modalRef.result;
  }

  onMapCollapseChange(collapsed: boolean) {
    this.showTabs = collapsed;
    requestAnimationFrame(() => {
      this.blenderViewers?.find((v) => !v.isFullscreenInstance)?.refreshViewport();
    });
  }

  private getSidebarBlenderViewer(): BlenderFloorViewerComponent | undefined {
    return this.blenderViewers?.find((viewer) => !viewer.isFullscreenInstance);
  }

  // --- Search helpers ---
  toggleSearch(): void {
    this.searchVisible = !this.searchVisible;
    if (!this.searchVisible) {
      this.clearSearch();
    }
  }

  clearSearch(): void {
    this.searchQuery = '';
    this.filteredUsers = [];
    // restore original columns if we have them
    if (this.origUserList1.length || this.origUserList2.length || this.origUserList3.length) {
      this.data.userList1 = [...this.origUserList1];
      this.data.userList2 = [...this.origUserList2];
      this.data.userList3 = [...this.origUserList3];
    }
  }

  onSearchChange(_: any): void {
    const q = (this.searchQuery || '').trim().toLowerCase();
    if (!q) {
      this.filteredUsers = [];
      // restore
      this.clearSearch();
      return;
    }
    const src = this.fullUsers || [];
    this.filteredUsers = src.filter((u: any) => (u?.name || '').toLowerCase().includes(q));
    this.data.page = 1;
    this.data.lastPage = Math.ceil(this.filteredUsers.length / this.data.limit);
    this.updateUserListsForPage();
  }

  private updateUserListsForPage(): void {
    // Ensure page is valid
    if (this.data.page > this.data.lastPage) {
      this.data.page = this.data.lastPage;
    }
    if (this.data.page < 1) {
      this.data.page = 1;
    }

    const startIndex = (this.data.page - 1) * this.data.limit;
    const endIndex = startIndex + this.data.limit;
    // Use filtered users if search is active, otherwise use all users
    const sourceUsers = this.searchQuery && this.searchQuery.length > 0 ? this.filteredUsers : this.fullUsers;
    const pageUsers = sourceUsers.slice(startIndex, endIndex);

    this.data.userList1 = pageUsers.slice(0, Math.ceil(pageUsers.length / 3));
    this.data.userList2 = pageUsers.slice(
      Math.ceil(pageUsers.length / 3),
      Math.ceil((pageUsers.length * 2) / 3)
    );
    this.data.userList3 = pageUsers.slice(
      Math.ceil((pageUsers.length * 2) / 3)
    );
  }

  private applyFilteredToColumns(): void {
    if (!this.filteredUsers || this.filteredUsers.length === 0) {
      // nothing to apply - restore originals
      this.clearSearch();
      return;
    }
    const users = this.filteredUsers;
    const len = users.length;
    const col1End = Math.ceil(len / 3);
    const col2End = Math.ceil((len * 2) / 3);
    this.data.userList1 = users.slice(0, col1End);
    this.data.userList2 = users.slice(col1End, col2End);
    this.data.userList3 = users.slice(col2End);
  }

  showUserInfoForGlb(user: any) {
    const entity = this.getDeviceMapEntityById(user.deviceId)
      || this.dataContext.getDevicemapEntityByDeviceId(user.deviceId);

    if (user.action === 'toggle' && !user.visible) {
      const modalRefs = this.windowService.openModalRefs;
      if (modalRefs) {
        Object.keys(modalRefs).forEach(key => {
          const modalRef = modalRefs[key];
          const mapEntity = modalRef?.componentInstance?.mapEntity;
          if (mapEntity) {
            const matchesUser =
              (mapEntity.arcAngelId && String(mapEntity.arcAngelId) === String(user.userId)) ||
              (mapEntity.arcAngelId && String(mapEntity.arcAngelId) === String(user.deviceId)) ||
              (mapEntity.deviceId && String(mapEntity.deviceId) === String(user.deviceId)) ||
              (mapEntity.id && String(mapEntity.id) === String(user.deviceId));
            if (matchesUser) {
              this.windowService.closeMapEntityDetailsWindow(key);
            }
          }
        });
      }

      if (entity) {
        this.windowService.closeMapEntityDetailsWindow('window-' + entity.id);
        this.windowService.closeMapEntityDetailsWindow(entity.getWindowId());
      }
      return;
    }

    if (entity) {
      this.showUsersInfoInWindow(entity);
    } else {
      const incident = this.liveData;
      if (!incident) return;
      this.deviceService.getIncidentDeviceDataByDeviceId(user, incident).subscribe({
        next: () => {
          setTimeout(() => {
            const newEntity = this.getDeviceMapEntityById(user.deviceId)
              || this.dataContext.getDevicemapEntityByDeviceId(user.deviceId);
            if (newEntity) {
              this.showUsersInfoInWindow(newEntity);
            }
          }, 100);
        },
        error: (err) => {
          console.error('Error fetching device data for user info window:', err);
        }
      });
    }
  }

}
